import $ from "jquery";
window.$ = window.jQuery = $;
import LazyLoad from "vanilla-lazyload";

import "slick-carousel";
import datepicker from "js-datepicker";
import AOS from "aos";

import "./scss/main.scss";

// lazyload
let images = document.querySelectorAll(".lazy");
new LazyLoad(images);

// slick slider
$(".workshops").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  prevArrow: $(".slider--prev"),
  nextArrow: $(".slider--next"),
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

// workshops
$(".slick-slide:first-of-type .workshops__item").addClass("active");
$(".workshops-content__item:first-of-type").addClass("active");

$(".workshops__item").click(function () {
  $(".workshops__item").removeClass("active");
  $(this).addClass("active");

  let currId = $(this).attr("id");

  $(".workshops-content__item").removeClass("active");
  $("#post-" + currId).addClass("active");
});

// smooth
$(document).on("click", 'a[href^="#"]', function (event) {
  event.preventDefault();

  $("html, body").animate(
    {
      scrollTop: $($.attr(this, "href")).offset().top - 150,
    },
    500
  );
});

// toggler
$(".navbar--toggler").click(function () {
  $(this).toggleClass("active");
  $(".main__menu").toggleClass("active");
});

// checkboxes
$('input[type="checkbox"]').click(function () {
  $(".other--input input").prop("disabled", true);
});

$(".other--checkbox input").change(function () {
  if ($(this).is(":checked")) {
    $(".other--input input").prop("disabled", false);
  } else {
    $(".other--input input").prop("disabled", true);
  }
});

// datepicker
const isdate = document.querySelectorAll(".date input");
if (isdate.length > 0) {
  const picker = datepicker(".date input", {
    formatter: (input, date, instance) => {
      const value = date.toLocaleDateString();
      input.value = value; // => '1/1/2099'
    },
    customMonths: [
      "Styczeń",
      "Luty",
      "Marzec",
      "Kwiecień",
      "Maj",
      "Czerwiec",
      "Lipiec",
      "Sierpień",
      "Wrzesień",
      "Październik",
      "Listopad",
      "Grudzień",
    ],
    customDays: ["Ndz", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"],
    noWeekends: true,
  });
}

// aos
AOS.init();
